var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('h1',[_vm._v("微信公众号授权登录")]),_c('button',{on:{"click":_vm.redirectToWeChatLogin}},[_vm._v("微信授权登录")]),(_vm.userInfo)?_c('div',[_c('h2',[_vm._v("用户信息")]),_c('p',[_vm._v("昵称: "+_vm._s(_vm.userInfo.nickname))]),_c('p',[_vm._v("头像: "),_c('img',{attrs:{"src":_vm.userInfo.headimgurl,"alt":"头像"}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }